import type { RefObject } from 'react';

import {
  DOCS_GET_STARTED,
  DOCS_HOME,
  DOCS_PRIVACY,
  DOCS_TOS,
} from 'constants/Docs.constants';
import type { PopupActions } from 'reactjs-popup/dist/types';

import { HelpIcon } from '@polyai/ui/components/atoms/Icons';
import {
  PopupMenu,
  PopupMenuItem,
} from '@polyai/ui/components/molecules/PopupMenu';

import useTemplateEngineUser from 'hooks/useTemplateEngineUser/useTemplateEngineUser';
import { useToast } from 'hooks/useToast';
import { getActionName } from 'lib/ddlogHelper';
import FadeButton from './FadeButton';
import { HELP_CENTER_MENU } from './HelpCenterMenu.uiCopy';

const HelpCenterMenu = ({
  isExpanded,
  popupRef,
}: {
  isExpanded: boolean;
  popupRef: RefObject<PopupActions | null>;
}) => {
  const { isTemplateEngineUser } = useTemplateEngineUser();
  const toast = useToast();

  const handleContactClick = async () => {
    await window.navigator.clipboard.writeText(
      HELP_CENTER_MENU.contact.contactEmail,
    );
    toast.success({
      title: HELP_CENTER_MENU.contact.contactToastTitle,
      description: HELP_CENTER_MENU.contact.contactToastMessage,
    });
  };

  return (
    <PopupMenu
      contentStyle={{
        width: 'auto',
        marginTop: '8px',
      }}
      offsetX={5}
      offsetY={-10}
      overlayStyle={{ display: 'none' }}
      popupRef={popupRef}
      position="right bottom"
      size="sm"
      trigger={
        <FadeButton
          isExpanded={isExpanded}
          aria-label="Help center"
          iconColor="iconPrimaryInverse"
          label="Help center"
          style={{ padding: '0.625rem' }}
          startAdornment={HelpIcon}
          type="button"
        />
      }
      nested
    >
      {isTemplateEngineUser ? (
        <PopupMenuItem onClick={handleContactClick}>
          {HELP_CENTER_MENU.items.contact}
        </PopupMenuItem>
      ) : (
        <>
          <PopupMenuItem
            data-dd-action={getActionName('Help', 'open', 'Getting Started')}
            forwardedAs="a"
            href={DOCS_GET_STARTED}
            rel="noreferrer"
            target="_blank"
          >
            {HELP_CENTER_MENU.items.gettingStarted}
          </PopupMenuItem>
          <PopupMenuItem
            data-dd-action={getActionName('Help', 'open', 'Help Centre')}
            forwardedAs="a"
            href={DOCS_HOME}
            rel="noreferrer"
            target="_blank"
          >
            {HELP_CENTER_MENU.items.helpCenter}
          </PopupMenuItem>
        </>
      )}
      <PopupMenuItem
        data-dd-action={getActionName('Help', 'open', 'Terms and Service')}
        forwardedAs="a"
        href={DOCS_TOS}
        rel="noreferrer"
        target="_blank"
      >
        {HELP_CENTER_MENU.items.termsOfService}
      </PopupMenuItem>
      <PopupMenuItem
        data-dd-action={getActionName('Help', 'open', 'Privacy Policy')}
        forwardedAs="a"
        href={DOCS_PRIVACY}
        rel="noreferrer"
        target="_blank"
      >
        {HELP_CENTER_MENU.items.privacyPolicy}
      </PopupMenuItem>
    </PopupMenu>
  );
};

export default HelpCenterMenu;
